module.exports = __webpack_public_path__ + "static/media/logo.6d39e361.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/logo.jpg
// module id = 129
// module chunks = 21